export const MARGINALIA_DATABASE_NAME = "marginalia" as const;
export const MARGINALIA_DATABASE_VERSION = 1 as const;

export const SCHEMA_V1 = {
  documents: "&id,&sha256,lastOpenedAt,updatedAt",
  pdfBlobs: "&documentId",
  annotations:
    "&id,documentId,pageIndex,[documentId+pageIndex],updatedAt,deletedAt",
  readingStates: "&documentId,updatedAt",
  pageTextCache:
    "&id,documentId,[documentId+pageIndex+extractorVersion],createdAt",
  settings: "&key",
} as const;
